var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tool-menu",style:({
    '--position-x': `${_vm.context.position.x}px`,
    '--position-y': `${_vm.context.position.y}px`,
  })},[_c('v-btn-toggle',{ref:"tools",staticClass:"tools",attrs:{"rounded":"","dense":"","dark":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }